export default __webpack_public_path__ + "static/media/planet.f5dcdcb8.png";